import { useQuery } from '@common-fe/common-fe';
import { OptionKey } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

export const SPEND_LIMIT_PERIODS_REMAINING_KEY = 'SPEND_LIMIT_PERIODS_REMAINING';

const useGetSpendLimitPeriodsRemainingQuery = (id?: string, period?: OptionKey) => {
  const { isLoading, isError, isSuccess, data } = useQuery(
    [SPEND_LIMIT_PERIODS_REMAINING_KEY, id, period],
    () =>
      api.get(API_URL.SPEND_LIMIT_PERIODS_REMAINING_BY_ACCOUNT_ID(id || ''), {
        params: { period_from: dayjs(period).format(DEFAULT_DATE_FORMAT) },
      }),
    {
      retry: false,
      enabled: Boolean(id && period),
      cacheTime: 0,
    }
  );

  return {
    data: data?.data,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetSpendLimitPeriodsRemainingQuery;
